export default __webpack_public_path__ + "static/media/goldenrecord.dae48366.jpg";